<template>
  <footer>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <!-- Logo -->
          <div class="logo-section">
            <div class="logo-circle">
              <img :src="empresarodape.url_logo" alt="logo" class="logo-image" />
            </div>
          </div>
          
          <!-- Social Media Text -->
          <div v-if="empresarodape.facebook || empresarodape.instagram || empresarodape.tiktok || empresarodape.youtube" class="social-text">
            <p>Siga em nossas redes sociais para conhecer mais dos produtos e promoções!</p>
          </div>
          
          <!-- Social Media Icons -->
          <div class="social-icons">
            <a v-if="empresarodape.facebook" :href="`https://www.facebook.com/${empresarodape.facebook}`" target="_blank" class="social-icon">
              <v-icon>mdi-facebook</v-icon>
            </a>
            <a v-if="empresarodape.instagram" :href="`https://www.instagram.com/${empresarodape.instagram}`" target="_blank" class="social-icon">
              <v-icon>mdi-instagram</v-icon>
            </a>
            <a v-if="empresarodape.tiktok" :href="`https://www.tiktok.com/@${empresarodape.tiktok}`" target="_blank" class="social-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-tiktok" viewBox="0 0 16 16">
                <path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z"/>
              </svg>
            </a>
            <a v-if="empresarodape.youtube" :href="`https://www.youtube.com/@${empresarodape.youtube}`" target="_blank" class="social-icon">
              <v-icon>mdi-youtube</v-icon>
            </a>
          </div>
          
          <!-- Info Columns -->
          <div class="row info-columns">
            <div class="col-md">
              <h3>Atendimento</h3>
              <p v-if="empresarodape.telefone">Tel: {{ empresarodape.telefone }}</p>
              <p>E-mail: {{ empresarodape.email }}</p>
            </div>
            <div v-if="empresarodape.whatsappcontato" class="col-md">
              <h3>WhatsApp</h3>
              <a :href="`https://wa.me/${empresarodape.whatsappcontato}`" target="_blank" class="whatsapp-icon">
                <img src="../../public/whatsapp.png" alt="WhatsApp" />
                {{empresarodape.whatsappcontato}}
              </a>
            </div>
            <div class="col-md">
              <h3>Loja Física</h3>
              <p>Endereço: {{ empresarodape.logradouro }}, Nº {{ empresarodape.numero }}, {{ empresarodape.bairro }}</p>
              <p>CEP: {{ empresarodape.cep }}, {{ empresarodape.cidade }}</p>
            </div>
          </div>
          
          <!-- Copyright and Credits -->
          <div class="copyright">
            <p>Todos os direitos reservados © {{ new Date().getFullYear() }}</p>
            <p class="credits">
              Desenvolvido por
              <a
                href="http://ciriuserp.com.br/"
                target="_blank"
                class="cirius-link"
              >
                Cirius ERP
                <img
                  src="../../public/logo.png"
                  alt="logo empresa"
                  class="cirius-logo"
                />
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: 'AppFooter',
  computed: {
    ...mapState("empresa", ["empresarodape"]),
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap");

footer {
  background-color: #EEEEEE;
  color: black;
  text-align: center;
  font-family: "Lato", sans-serif;
  padding: 40px 0;
}

.logo-section {
  margin-bottom: 20px;
}

.logo-circle {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
  margin: 0 auto;
}

.logo-circle:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.logo-image {
  width: 160px;
  height: auto;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.logo-circle:hover .logo-image {
  transform: scale(1.05);
}

.social-text {
  margin: 20px 0;
  font-size: 1.1em;
}

.social-icons {
  margin: 20px 0;
}

.social-icon {
  color: #13433a;
  font-size: 24px;
  margin: 0 15px;
  text-decoration: none;
  transition: color 0.3s ease;
}

.social-icon:hover {
  color: #0d2c26;
}

.social-icon svg {
  width: 24px;
  height: 24px;
}

.info-columns {
  margin: 40px 0;
  text-align: center;
}

.info-columns h3 {
  color: #13433a;
  margin-bottom: 15px;
  font-size: 1.2em;
}

.info-columns p {
  margin: 5px 0;
}

.copyright {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #ddd;
}

.credits {
  margin-top: 15px;
  font-size: 0.9em;
}

.cirius-link {
  color: forestgreen;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  transition: color 0.3s ease;
}

.cirius-link:hover {
  color: #1a6b1a;
}

.cirius-logo {
  width: 40px;
  margin-left: 10px;
  vertical-align: middle;
}

.whatsapp-icon {
  display: inline-flex;
  align-items: center;
  color: #13433a;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.whatsapp-icon img {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

.whatsapp-icon:hover {
  color: #0d2c26;
}
</style> 